import { onMounted, onUnmounted, type Ref } from 'vue';

export type KeyHandler = (e: KeyboardEvent) => boolean | void;

function isTypingTarget(target: EventTarget | null): boolean {
  if (!target || !(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  return target.isContentEditable;
}

export function useKeyboard(
  handler: KeyHandler,
  options?: { enabled?: () => boolean },
) {
  function onKey(e: KeyboardEvent) {
    if (options?.enabled && !options.enabled()) return;
    if (isTypingTarget(e.target)) return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    const handled = handler(e);
    if (handled) e.preventDefault();
  }

  onMounted(() => window.addEventListener('keydown', onKey));
  onUnmounted(() => window.removeEventListener('keydown', onKey));
}

export function useModeKeyboard(
  mode: Ref<string>,
  expected: string,
  handler: KeyHandler,
) {
  useKeyboard(handler, { enabled: () => mode.value === expected });
}
